import React from "react";
import { Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import InfoRow from "./InfoRow.tsx";

import { ElectricalData } from "../ProjectDetails.types.tsx";

import { SubHeaderLabel } from "../../Labels.tsx";

const ElectricalDataCard: React.FC<{ electricalData: ElectricalData }> = ({ electricalData }) => {
  const { t } = useTranslation();

  const {
    name,
    compressor_type = [],
    compressor_quantity,
    per_compressor_amps,
    compressor_rla,
    compressor_lra,
    per_compressor_kw,
    heat_rejection,
    condenser_type,
    per_fan_amps,
  } = electricalData || {};

  return (
    <Card className="border-0 h-100">
      <Card.Body className="d-flex flex-column">
        <SubHeaderLabel textAlign="left" className="mb-2">
          {name}
        </SubHeaderLabel>

        <div className="flex-grow-1">
          <InfoRow
            label={`${t("projectDetails.electricalDataCard.compressorType")}:`}
            value={compressor_type[0]}
          />
          <InfoRow
            label={`${t("projectDetails.electricalDataCard.compressorQuantity")}:`}
            value={compressor_quantity}
          />
          <InfoRow
            label={`${t("projectDetails.electricalDataCard.perCompressorAmps")}:`}
            value={per_compressor_amps}
          />
          <InfoRow
            label={`${t("projectDetails.electricalDataCard.compressorRLA")}:`}
            value={compressor_rla}
          />
          <InfoRow
            label={`${t("projectDetails.electricalDataCard.compressorLRA")}:`}
            value={compressor_lra}
          />
          <InfoRow
            label={`${t("projectDetails.electricalDataCard.perCompressorKW")}:`}
            value={per_compressor_kw}
          />
          <InfoRow
            label={`${t("projectDetails.electricalDataCard.heatRejectionKW")}:`}
            value={heat_rejection}
          />
          <InfoRow
            label={`${t("projectDetails.electricalDataCard.condenserType")}:`}
            value={condenser_type}
          />
          <InfoRow
            label={`${t("projectDetails.electricalDataCard.perFanAmps")}:`}
            value={per_fan_amps}
          />
        </div>
      </Card.Body>
    </Card>
  );
};

export default ElectricalDataCard;
